import { useId } from 'react';
import { ArrowsDownUp, CaretDown } from '@phosphor-icons/react';

interface SortOption {
  label: string;
  value: string;
}

interface SortFilterProps {
  options: SortOption[];
  value: string;
  onChange: (value: string) => void;
}

export const SortFilter = ({ options, value, onChange }: SortFilterProps) => {
  const selectId = useId();

  return (
    <div className="relative">
      <ArrowsDownUp
        size={18}
        aria-hidden="true"
        className="text-text-body pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
      />
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Sort reports by date"
        className="border-ui-border text-body text-text-body focus:ring-action-link appearance-none rounded border bg-white py-2 pl-9 pr-10 focus:outline-none focus:ring-2"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <CaretDown
        size={16}
        aria-hidden="true"
        className="text-text-body pointer-events-none absolute right-3 top-1/2 -translate-y-1/2"
      />
    </div>
  );
};
